import enumeration from "./enumeration";

const DiscountType = {
  Fixed: "FIXED",
  Percentage: "PERCENTAGE",
};

export default enumeration(DiscountType);
